function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_277_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_292_",
    d: "m202.184 164.159-3.269 1.347c-5.502-9.613-15.854-16.109-27.701-16.109h-50.618c-17.591 0-31.902 14.311-31.902 31.902v143.967c0 17.591 14.312 31.902 31.902 31.902h50.618c10.022 0 18.975-4.65 24.828-11.901 17.614 7.804 36.851 11.901 56.124 11.901h106.957c17.938 0 32.532-14.594 32.532-32.532 0-5.612-1.429-10.896-3.941-15.51 11.18-5.153 18.963-16.46 18.963-29.556 0-5.383-1.322-10.46-3.646-14.937 11.881-4.851 20.278-16.525 20.278-30.129s-8.397-25.278-20.278-30.128c2.324-4.477 3.646-9.554 3.646-14.937 0-17.938-14.594-32.533-32.532-32.533h-53.291c-5.037 0-9.135-4.098-9.135-9.135v-29.417c0-29.328-23.859-53.188-53.188-53.188-12.86 0-23.323 10.463-23.323 23.323v26.348c-.001 21.698-12.963 41.058-33.024 49.322zm-30.971 173.009h-50.618c-6.563 0-11.902-5.34-11.902-11.902v-143.967c0-6.562 5.339-11.902 11.902-11.902h50.618c6.563 0 11.902 5.34 11.902 11.902v143.967c0 6.562-5.339 11.902-11.902 11.902zm83.994-222.329v-26.348c0-1.832 1.491-3.323 3.323-3.323 18.3 0 33.188 14.888 33.188 33.188v29.417c0 16.065 13.069 29.135 29.135 29.135h53.291c6.91 0 12.532 5.622 12.532 12.533 0 6.91-5.622 12.532-12.532 12.532h-62.412c-5.522 0-10 4.477-10 10 0 5.522 4.478 10 10 10h79.043c6.911 0 12.533 5.622 12.533 12.532 0 6.911-5.622 12.533-12.533 12.533h-79.043c-5.522 0-10 4.477-10 10 0 5.522 4.478 10 10 10h62.412c6.91 0 12.532 5.622 12.532 12.532s-5.622 12.532-12.532 12.532h-62.412c-5.522 0-10 4.478-10 10s4.478 10 10 10h47.391c6.91 0 12.532 5.622 12.532 12.533 0 6.91-5.622 12.532-12.532 12.532h-106.958c-16.88 0-33.723-3.683-49.081-10.673.016-.408.031-.817.031-1.229v-139.86l6.687-2.754c27.582-11.363 45.405-37.98 45.405-67.812z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    d: "m422 20h-121c-5.522 0-10 4.478-10 10s4.478 10 10 10h121c38.598 0 70 31.402 70 70v232c0 38.598-31.402 70-70 70h-131.359c-3.572 0-6.874 1.906-8.66 5l-25.981 45-25.981-45c-1.786-3.094-5.087-5-8.66-5h-131.359c-38.598 0-70-31.402-70-70v-232c0-38.598 31.402-70 70-70h120.999c5.523 0 10-4.478 10-10s-4.477-10-10-10h-120.999c-49.626 0-90 40.374-90 90v232c0 49.626 40.374 90 90 90h125.585l31.754 55c1.786 3.094 5.087 5 8.66 5 3.572 0 6.874-1.906 8.66-5l31.754-55h125.587c49.626 0 90-40.374 90-90v-232c0-49.626-40.374-90-90-90z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    d: "m256 40c2.63 0 5.2-1.07 7.069-2.931 1.861-1.859 2.931-4.439 2.931-7.069s-1.07-5.21-2.931-7.07c-1.859-1.861-4.439-2.93-7.069-2.93s-5.21 1.069-7.07 2.93c-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.861 4.44 2.931 7.07 2.931z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.382ef389ab9eb0edef3eaf8dedc60237.svg";
export { ForwardRef as ReactComponent };